// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F7Tm","label":"styles_label__3xfV0"};